import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
  Text,
  Flex,
} from '@chakra-ui/react';
import { FaPlus, FaMinus } from 'react-icons/fa6';
import DOMPurify from 'dompurify';
import ComponentFactory from './Factory/ComponentFactory';

const AccordionComponent = ({ items }) => {
  const [expandedIndices, setExpandedIndices] = useState([]);

  // Reset expanded state when items change (e.g., when navigating to next page)
  useEffect(() => {
    setExpandedIndices([]);
  }, [items]);

  const handleChange = (indices) => {
    // Chakra passes an array when allowMultiple is true
    setExpandedIndices(Array.isArray(indices) ? indices : [indices]);
  };

  const truncateContent = (content, isExpanded) => {
    const maxLength = 40;
    if (isExpanded || content.length <= maxLength) {
      return content;
    }
    return content.substring(0, maxLength) + '...';
  };

  return (
    <Accordion allowMultiple index={expandedIndices} onChange={handleChange} mb={8}>
      {items.map((item, index) => {
        const isExpanded = expandedIndices.includes(index);

        return (
          <AccordionItem
            key={item.id ?? index}
            border="none"
            borderBottom="1px solid var(--sutter-sync-purple)"
          >
            <>
              <h2>
                <AccordionButton
                  py={2}
                  pb={1}
                >
                  <Flex flex="1" textAlign="left" direction="column">
                    <Text
                      as="span"
                      fontFamily={`var(--${item.titleVariant || 'body-lg-min-reg'}-font-family)`}
                      fontSize={`var(--${item.titleVariant || 'body-lg-min-reg'}-font-size)`}
                      fontWeight={`var(--${item.titleVariant || 'body-lg-min-reg'}-font-weight)`}
                      lineHeight={`var(--${item.titleVariant || 'body-lg-min-reg'}-line-height)`}
                      color={item.titleColor || 'var(--sutter-sync-purple)'}
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(item.title),
                      }}
                    />
                  </Flex>
                  <Box>
                    {isExpanded ? (
                      <Box
                        as={FaMinus}
                        color="var(--sutter-sync-purple)"
                        size="16px"
                      />
                    ) : (
                      <Box
                        as={FaPlus}
                        color="var(--sutter-sync-purple)"
                        size="16px"
                      />
                    )}
                  </Box>
                </AccordionButton>
              </h2>
              {!isExpanded && (
                <Text
                  fontFamily={`var(--${item.contentVariant || 'body-sm-min-reg'}-font-family)`}
                  fontSize={`var(--${item.contentVariant || 'body-sm-min-reg'}-font-size)`}
                  fontWeight={`var(--${item.contentVariant || 'body-sm-min-reg'}-font-weight)`}
                  lineHeight={`var(--${item.contentVariant || 'body-sm-min-reg'}-line-height)`}
                  color={item.contentColor || 'var(--color-dusky-teal)'}
                  px={4}
                  pb={2}
                  aria-hidden="true"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      truncateContent(item.content[0]?.content || '', false)
                    ),
                  }}
                />
              )}
              <AccordionPanel pb={4}>
                {item.content.map((contentItem, contentIndex) => (
                  <ComponentFactory
                    key={contentIndex}
                    section={contentItem}
                    theme="light"
                    priorDecisions={[]}
                    formData={{}}
                    updateFormData={() => {}}
                    handleButtonAction={() => {}}
                  />
                ))}
              </AccordionPanel>
            </>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};

export default AccordionComponent;
